import type { Attachment } from '@/entities/shared/attachment/attachment';
import type { Item } from '../schemas/item';

/** The picture that stands for the item in lists: its first image attachment. */
export function coverOf(item: Item): Attachment | undefined {
  return item.attachments.find((attachment) => attachment.type.startsWith('image/'));
}
